/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UploadFileInput } from './UploadFileInput';
import {
    UploadFileInputFromJSON,
    UploadFileInputFromJSONTyped,
    UploadFileInputToJSON,
    UploadFileInputToJSONTyped,
} from './UploadFileInput';

/**
 * 
 * @export
 * @interface UploadDocumentInput
 */
export interface UploadDocumentInput {
    /**
     * 
     */
    client_request_id: string;
    /**
     * 
     */
    display_name: string;
    /**
     * 
     */
    files: Array<UploadFileInput>;
}

/**
 * Check if a given object implements the UploadDocumentInput interface.
 */
export function instanceOfUploadDocumentInput(value: object): value is UploadDocumentInput {
    if (!('client_request_id' in value) || value['client_request_id'] === undefined) return false;
    if (!('display_name' in value) || value['display_name'] === undefined) return false;
    if (!('files' in value) || value['files'] === undefined) return false;
    return true;
}

export function UploadDocumentInputFromJSON(json: any): UploadDocumentInput {
    return UploadDocumentInputFromJSONTyped(json, false);
}

export function UploadDocumentInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadDocumentInput {
    if (json == null) {
        return json;
    }
    return {
        
        'client_request_id': json['client_request_id'],
        'display_name': json['display_name'],
        'files': ((json['files'] as Array<any>).map(UploadFileInputFromJSON)),
    };
}

export function UploadDocumentInputToJSON(json: any): UploadDocumentInput {
    return UploadDocumentInputToJSONTyped(json, false);
}

export function UploadDocumentInputToJSONTyped(value?: UploadDocumentInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'client_request_id': value['client_request_id'],
        'display_name': value['display_name'],
        'files': ((value['files'] as Array<any>).map(UploadFileInputToJSON)),
    };
}

